/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Stack} from '@chakra-ui/react'
import useRegistrationFields from './useRegistrationFields'
import Field from '../field'
import PasswordRequirements from './password-requirements'
import {useWatch} from 'react-hook-form'
import useOcapiSite from '../../hooks/useOcapiSite'

const RegistrationFields = ({form, prefix = ''}) => {
    const fields = useRegistrationFields({form, prefix})
    const password = useWatch({control: form.control, name: 'password'})
    const {newsletterPreselected} = useOcapiSite()

    return (
        <Stack spacing={6}>
            <Field {...fields.firstName} />
            <Field {...fields.lastName} />
            <Field {...fields.email} />

            <Stack spacing={3}>
                <Field {...fields.password} />
                <PasswordRequirements value={password} />
            </Stack>

            <Box paddingTop={2}>
                <Field {...fields.newsletter} defaultValue={newsletterPreselected} />
            </Box>
        </Stack>
    )
}

RegistrationFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default RegistrationFields
